import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
  providedIn: "root",
})
export class AlertService {
  /**
   * Show snackbar
   * @param message
   * @param action
   */
  showSnackBar(message: string, action?: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: "bottom",
      horizontalPosition: "end",
    });
  }

  constructor(private snackBar: MatSnackBar) {}
}
